<template>
    <div>
        <template v-if="showContent">
            <div ref="contentWrapper">
                <div class="post-content normal-text" v-html="currentContent"></div>
            </div>
            <p class="secondary-c inline hover-opacity topic-read-more no-select"
               style="margin-left: 8px;"
               v-if="topic.content.length > 200 && !expandedTopic && (displayMode === 'big' || isHelpdesk)"
               @click="expandTopic(topic)">... {{ $t('forum.read_more').toLowerCase() }}</p>
        </template>
        <template v-else>
            <slot name="dynamicContent"></slot>
        </template>
        <div class="responsive-video embed-16-by-9"
             v-if="videoPreview && topic.permissions.includes('READ')">
            <iframe :src="videoPreview" class="topic-video" frameborder="0"
                    allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </div>
        <div class="post-attachments" :class="{'hidden' : viewType === 'moodview'}">
            <template v-if="topic.permissions.includes('READ')">
                <lightbox :images="images" thumbnailSrc="source" src="source" customImageClass="post-attachment"></lightbox>
                <div class="attachment-files" v-if="attachments.length > 0">
                    <div v-for="attachment in attachments" class="file small-text light-text hover-opacity">
                        <audio controls class="tw-outline-none tw-mt-3 tw-w-full" v-if="audio_types.includes(attachment.filetype)">
                            <source :src="attachment.source" :type="attachment.filetype">
                        </audio>
                        <a :href="attachment.source" target="_blank" v-else>
                            <i class="far fa-paperclip"></i>
                            <p class="inline-block">{{ attachment.name }}</p>
                        </a>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import Feed from '../../mixins/Feed.js'
    import VideoRegexMixin from '../../mixins/v2/VideoRegexMixin.js'

    export default {
        mixins: [Feed, VideoRegexMixin],

        props: {
            topic: {
                required: true
            },
            viewType: {
                required: true
            },
            showContent: {
                default: true,
            },
            expandedTopic: {
                required: true,
            }
        },

        data() {
            return {
                isHelpdesk: isHelpdesk,
                audio_types: ['audio/mpeg', 'audio/ogg', 'audio/wav'],
                tenant_id,
            }
        },

        computed: {
            ...mapState([
                'displayMode',
            ]),

            topicExcerpt() {
                return this.contentFilter(this.topic, true, 200);
            },

            topicContent() {
                return this.contentFilter(this.topic, false, false);
            },

            currentContent() {
                return this.expandedTopic ? this.topicContent : this.topicExcerpt;
            },

            videoPreview() {
                if (this.topic.video_url !== '' && this.topic.video_url !== '0' && this.topic.video_url !== null) {
                    return this.videoRegex(this.topic.video_url);
                }

                return false;
            },

            attachments() {
                return this.topic.attachments.filter(attachment => !attachment.filetype.startsWith('image/'));
            },

            images() {
                return this.topic.attachments.filter(attachment => attachment.filetype.startsWith('image/'));
            },
        },

        methods: {
            expandTopic(topic) {
                this.$parent.expandTopic(topic);
            },

            videoRegex(url) {
                return this.parsedVideo(url);
            },

            addCopyEventListener(element) {
                const self = this;

                element.addEventListener("copy", (event) => {
                    const selection = document.getSelection();
                    if (!selection || !self.$settings('domain')) {
                        return;
                    }

                    const selectedText = selection.toString().replace("http://", "https://");
                    const secureDomain = self.$settings('domain').replace("http://", "https://");

                    if (selectedText.startsWith(secureDomain)) {
                        const newText = selectedText.replace(
                            secureDomain,
                            `https://link.thehuddle.nl/${this.tenant_id}`,
                        );
                        if (event.clipboardData) {
                            event.clipboardData.setData("text/plain", newText);
                            event.preventDefault();
                        }
                    }
                });
            },
        },

        mounted() {
            this.addCopyEventListener(this.$refs.contentWrapper);
        },

        destroyed() {
            this.$refs.contentWrapper.removeEventListener("copy", this.addCopyEventListener);
        }
    }
</script>
